import { logDOM } from "@testing-library/react";
import React, { useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { chargenow } from "../../../API/API";
import { Close } from "../../Common/Images/Images";
import "./clientchargenowmodalStyle.scss";
export const ClientChargeNowModal = ({
  setloader,
  client_data,
  setclientchargenowmodal,
  setcurrent_showing_client_data,
}) => {
  // console.log("client_data", client_data);
  const navigate = useNavigate();
  const [current_active, setcurrent_active] = useState("");
  const [card_err, setcard_err] = useState(false);
  const [card_api_err, setcard_api_err] = useState("");
  const [card_dropdown, setcard_dropdown] = useState(false);
  const [card_dropdown_active, setcard_dropdown_active] = useState(false);
  const [current_selected_card, setcurrent_selected_card] = useState();
  const [payment_details, setpayment_details] = useState({
    failed_cards: [],
  });

  const current_store = useSelector((state) => state);
  let total = client_data.pay_later_amount || 0;
  //   let total = 100;
  let data = {
    payment: null,
    card_list: client_data.cards || [],
  };

  useLayoutEffect(() => {
    if (data.payment == null && data.card_list.length == 0) {
      setcard_err(true);
    }
    if (payment_details.failed_cards.length != 0) {
      setcard_dropdown(true);
      if (
        data.card_list.filter(
          (el) =>
            [
              ...payment_details.failed_cards,
              data.card_list.filter((el) => el.is_primary == "1")[0],
            ]
              .map((el) => el.id)
              .indexOf(el.id) == -1
        ).length == 0
      ) {
        setcard_err(true);
      }
    }
    setcurrent_selected_card(
      data.card_list.length == 0
        ? ""
        : data.card_list.filter((el) => el.is_primary == "1")[0].id
    );
  }, []);
  const handelchargenow = () => {
    if (
      ["card", "cash", "mark_as_charged", "manual_card", "pay_later"].indexOf(
        current_active
      ) == -1
    ) {
      return;
    }
    let default_card_obj = {
      user_id: client_data.id,
      amount: client_data.pay_later_amount,
      dateTime: new Date(),
    };
    switch (current_active) {
      case "card":
        if (current_selected_card != "") {
          let card_obj = {
            ...default_card_obj,
            card_id: current_selected_card,
            payment_type: current_active,
          };
          setloader(true);
          chargenow(
            {
              ...card_obj,
            },
            current_store.user.token,
            (data1) => {
              if (data1.card_debit_error) {
                setpayment_details({
                  ...payment_details,
                  failed_cards: [
                    ...payment_details.failed_cards,
                    data.card_list.filter(
                      (el) => el.id == current_selected_card
                    )[0],
                  ],
                });
                setcurrent_selected_card("");
                setcard_dropdown(true);
                if (
                  data.card_list.filter(
                    (el) =>
                      [
                        ...payment_details.failed_cards,
                        data.card_list.filter(
                          (el) => el.id == current_selected_card
                        )[0],
                      ]
                        .map((el) => el.id)
                        .indexOf(el.id) == -1
                  ).length == 0
                ) {
                  setcard_err(true);
                }
                setloader(false);
              } else {
                if (!data1.status) {
                  setloader(false);
                  return navigate("/404");
                }
                setpayment_details({
                  ...payment_details,
                  payed_as: {
                    ...card_obj,
                    card_data: data.card_list.filter(
                      (el) => el.id == current_selected_card
                    )[0],
                  },
                  payed: true,
                });
                setclientchargenowmodal(false);
                setcurrent_showing_client_data((prev) => ({
                  ...prev,
                  pay_later_amount: 0,
                  paidTotal: 0,
                }));
                setloader(false);
              }
            }
          );
        }
        break;
      case "cash":
        let cash_obj = {
          //   order_id: data.order_id,
          //   amount: total,
          //   //   delivery: delivery,
          //   client_id: data.client_id,
          //   dateTime: new Date(),
          // card_id: "",
          ...default_card_obj,
          payment_type: current_active,
        };
        setloader(true);
        chargenow(
          {
            ...cash_obj,
          },
          current_store.user.token,
          (data1) => {
            if (!data1.status) {
              setloader(false);
              return navigate("/404");
            }
            // setstatuses([...data1.data.statusLogs]);
            setpayment_details({
              ...payment_details,
              payed_as: {
                ...cash_obj,
              },
              payed: true,
            });
            setclientchargenowmodal(false);
            setcurrent_showing_client_data((prev) => ({
              ...prev,
              pay_later_amount: 0,
              paidTotal: 0,
            }));
            setloader(false);
          }
        );
        break;
      case "mark_as_charged":
        let cash_obj1 = {
          // order_id: data.order_id,
          // amount: total,
          // //   delivery: delivery,
          // client_id: data.client_id,
          // payment_type: current_active,
          // // card_id: current_selected_card,
          // dateTime: new Date(),
          ...default_card_obj,
          payment_type: current_active,
        };
        setloader(true);
        chargenow(
          {
            ...cash_obj1,
          },
          current_store.user.token,
          (data1) => {
            if (!data1.status) {
              setloader(false);
              return navigate("/404");
            }
            // setstatuses([...data1.data.statusLogs]);
            setpayment_details({
              ...payment_details,
              payed_as: {
                ...cash_obj1,
              },
              payed: true,
            });
            setclientchargenowmodal(false);
            setcurrent_showing_client_data((prev) => ({
              ...prev,
              pay_later_amount: 0,
              paidTotal: 0,
            }));
            setloader(false);
          }
        );
        break;
      case "manual_card":
        {
          // return;
          let cash_obj1 = {
            // order_id: data.order_id,
            // amount: total,
            // // delivery: delivery,
            // client_id: data.client_id,
            // payment_type: current_active,
            // dateTime: new Date(),
            ...default_card_obj,
            // card_id: "",
            payment_type: current_active,
          };
          setloader(true);
          chargenow(
            {
              ...cash_obj1,
            },
            current_store.user.token,
            (data1) => {
              if (!data1.status) {
                setloader(false);
                if (
                  data1.status == false &&
                  data1.err_msg &&
                  data1.err_msg == "try again later"
                ) {
                  return;
                }
                navigate("/404");
                return;
              }
              //   setstatuses([...data1.data.statusLogs]);
              setpayment_details({
                ...payment_details,
                payed_as: {
                  ...cash_obj1,
                },
                payed: true,
              });
              setclientchargenowmodal(false);
              setcurrent_showing_client_data((prev) => ({
                ...prev,
                pay_later_amount: 0,
                paidTotal: 0,
              }));
              setloader(false);
            }
          );
        }
        break;
      case "pay_later":
        {
          let cash_obj1 = {
            // order_id: data.order_id,
            // amount: total,
            // // delivery: delivery,
            // client_id: data.client_id,
            // payment_type: current_active,
            // dateTime: new Date(),
            ...default_card_obj,
            payment_type: current_active,
          };
          setloader(true);
          chargenow(
            {
              ...cash_obj1,
            },
            current_store.user.token,
            (data1) => {
              if (!data1.status) {
                setloader(false);
                navigate("/404");

                return;
              }
              //   setstatuses([...data1.data.statusLogs]);
              setpayment_details({
                ...payment_details,
                payed_as: {
                  ...cash_obj1,
                },
                payed: true,
              });
              setclientchargenowmodal(false);
              setcurrent_showing_client_data((prev) => ({
                ...prev,
                pay_later_amount: 0,
                paidTotal: 0,
              }));
              setloader(false);
            }
          );
        }
        break;

      default:
        break;
    }
  };
  return (
    <div className="clientchargenowmodal">
      <div className="chargeordermodal_main">
        <div className="chargeordermodal_header">
          <div className="heading" style={{ height: "78px" }}>
            Payment Method
          </div>
          <Close
            clickhandel={() => {
              setclientchargenowmodal(false);
            }}
          />
        </div>
        <div className="chargeordermodal_body">
          <div className="cards">
            {card_err && payment_details.failed_cards.length > 0 && (
              <div
                className="card_body"
                onClick={() => {
                  setpayment_details({
                    ...payment_details,
                    failed_cards: [],
                  });
                  setclientchargenowmodal(false);
                  setTimeout(() => {
                    setclientchargenowmodal(true);
                  }, 10);
                }}
              >
                <div>Reset Card</div>
                <div>on file</div>
              </div>
            )}
            {!(payment_details.payment == "" || card_err) ? (
              <div
                className={
                  "card_body" +
                  (current_active == "card" ? " card_body_active" : "")
                }
                card_disabled={(
                  payment_details.payment == "" || card_err
                ).toString()}
                onClick={() => {
                  setcurrent_active("card");
                  if (card_dropdown) {
                    setcard_dropdown_active(!card_dropdown_active);
                  }
                }}
              >
                {!card_dropdown ? (
                  <>
                    <div>Credit Card</div>
                    <div>on file</div>
                  </>
                ) : (
                  <>
                    <div>Other Credit</div>
                    <div>Card on file</div>
                    <div
                      className={
                        "cc_card_dropdown" +
                        (card_dropdown_active ? " card_dropdown_active" : "")
                      }
                      style={
                        card_dropdown_active
                          ? {
                              height: `${
                                12 +
                                data.card_list.filter(
                                  (el) =>
                                    payment_details.failed_cards
                                      .map((el) => el.id)
                                      .indexOf(el.id) == -1
                                ).length *
                                  31
                              }px`,
                            }
                          : {}
                      }
                    >
                      <div>
                        {data.card_list
                          .filter(
                            (el) =>
                              payment_details.failed_cards
                                .map((el) => el.id)
                                .indexOf(el.id) == -1
                          )
                          .map((el) => (
                            <div
                              className={
                                "cc_card_body" +
                                (current_selected_card == el.id
                                  ? " current_selected_card"
                                  : "")
                              }
                              onClick={() => {
                                setcurrent_selected_card(el.id);
                              }}
                            >
                              **** **** {el.cc_last_4_digits}
                            </div>
                          ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ) : (
              ""
            )}
            <div
              className={
                "card_body" +
                (current_active == "manual_card" ? " card_body_active" : "")
              }
              onClick={() => {
                setcurrent_active("manual_card");
                if (card_dropdown) {
                  setcard_dropdown_active(false);
                }
              }}
            >
              <div>Credit Card</div>
              <div>to swipe</div>
            </div>
            <div
              className={
                "card_body" +
                (current_active == "cash" ? " card_body_active" : "")
              }
              onClick={() => {
                setcurrent_active("cash");
                if (card_dropdown) {
                  setcard_dropdown_active(false);
                }
              }}
            >
              <div>Accept</div>
              <div>Cash</div>
            </div>
            <div
              className={
                "card_body" +
                (current_active == "mark_as_charged" ? " card_body_active" : "")
              }
              onClick={() => {
                setcurrent_active("mark_as_charged");
                if (card_dropdown) {
                  setcard_dropdown_active(false);
                }
              }}
            >
              <div>Mark as</div>
              <div>Charged</div>
            </div>

            {card_api_err && (
              <div className="card_body card_error">Error: {card_api_err} </div>
            )}
          </div>
        </div>
        <div className="chargeordermodal_footer">
          <div className="total_due">
            <div>Total Due:</div>
            <div>${total}</div>
          </div>
          <div className="charge_now">
            <div className="btn" type="type2" onClick={handelchargenow}>
              Charge Now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
